import { OnlinePatientManagementContext } from "@ngt/opms";
import { useCallback, useContext } from "react";
import { PostPatientSetPreferredLanguage } from "../../api/dtos";

const useSetLanguagePreferences = () => {
    const { serviceStackClient } = useContext(OnlinePatientManagementContext);

    const setLanguagePreferences = useCallback(async (patientId?: number, localeId?: number) => {
        if(patientId && localeId) {
            await serviceStackClient.post(new PostPatientSetPreferredLanguage({patientId, localeId}));
        }
    }, [serviceStackClient]);

    return setLanguagePreferences;
}

export default useSetLanguagePreferences;